/**
 * API文档地址
 * http://yapi.kapeixi.cn/project/777/interface/api/cat_4627
 */

import { message } from 'ant-design-vue'
import {
  staff_list_post,
  staff_list_config_post,
  staff_list_config_all_post,
  staff_update_post,
  staff_list_depart_post
} from 'server/modules/4627'

// 员工信息查询
export const staff_list_post_ = async function(params) {
  const { success, data, retInfo } = await staff_list_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 员工信息查询
export const staff_list_config_post_ = async function(params) {
  const { success, data, retInfo } = await staff_list_config_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 员工所有信息查询
export const staff_list_config_all_post_ = async function(params) {
  const { success, data, retInfo } = await staff_list_config_all_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 员工信息更新
export const staff_update_post_ = async function(params) {
  const { success, data, retInfo } = await staff_update_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 组织架构查询
export const staff_list_depart_post_ = async function(params) {
  const { success, data, retInfo } = await staff_list_depart_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}
